import React from 'react';
import DataResource from '../../common/v4/DataResource'
import Panel from '../../common/layout/Panel'

export default class extends React.Component {
    render () {
        const data =  {
            url: '/admin/products/products',
            loading: false,
            data: {
                data: [],
                metadata: []
            },
            onclick: 'link',
            link: '/products/products/{id}',
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRPRODUCTID',
                        type: 'primary',
                        editable: false,
                        visible: false
                    },
                    {
                        label: 'Profile Name',
                        source: 'ATRPRODUCTNAME',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'name'
                    },
                    {
                        label: 'Type',
                        source: 'ATRPRODUCTTYPE',
                        type: 'select',
                        editable: false,
                        visible: true,
                        default: '1'
                    },
                    {
                        label: 'Description',
                        source: 'ATRPRODUCTDESCR',
                        type: 'text',
                        editable: true,
                        visible: true,
                        placeholder: 'optional description'
                    },
                    {
                        label: 'Created At',
                        source: 'ATRCREATETIME',
                        type: 'text',
                        editable: false,
                        visible: true,
                        visible_add: false
                    },
                    {
                        label: 'Enabled',
                        source: 'ATRSTATUS',
                        type: 'boolean',
                        editable: true,
                        visible: true,
                        default : true
                    },
                    {
                        label: 'Delete',
                        type: 'delete',
                        visible: true
                    }
                ]
        }
        return (
            <Panel title = "Rate Profiles">
                <DataResource
                    addButtonText = "Create Rate Profile"   
                    addButtonLink = "/products/rate_profiles/create"                 
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}